import { render, staticRenderFns } from "./DrinkDialog.vue?vue&type=template&id=88f67bde&"
import script from "./DrinkDialog.vue?vue&type=script&lang=js&"
export * from "./DrinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports